var map = {
	"./knowaboutus_logo1.svg": 490,
	"./knowaboutus_logo2.svg": 9802,
	"./knowaboutus_logo3.svg": 4150,
	"./knowaboutus_logo4.svg": 1457,
	"./knowaboutus_logo5.svg": 5626,
	"./knowaboutus_logo6.svg": 5802
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 669;